import React from "react";
import "react-calendar/dist/Calendar.css";
import HouseKeepingCharterTable from "./HouseKeepingCharterTable";
import { connect } from "react-redux";
import HouseKeepingCharterTable2 from "./HouseKeepingCharterTable2";

function HouseKeepingCharter2(props) {
  const hotelId = props.data.hotelId;

  return (
    <div className="houseKeepingCharterWrapper">
      {/* <div className="hkTableWrapper"> */}
      <HouseKeepingCharterTable2 selectedLanguage={props.selectedLanguage} />
      {/* </div> */}
    </div>
  );
}

function mapStateToProps(state) {
  return { data: state.auth.selectedHotel };
}
export default connect(mapStateToProps)(HouseKeepingCharter2);
